
  export default {
    name: 'ProtocolNav',
    props: {
      active: {
        type: String,
        default: 'aifwxy',
      },
    },
    methods: {},
  }
